export const header = {
  navigation: {
    features: 'Características',
    businessTypes: 'Tipos de Negocio',
    testimonials: 'Testimonios',
    contact: 'Contacto',
    dashboard: 'Panel de Control',
    subscription: 'Suscripción'
  },
  auth: {
    login: 'Iniciar Sesión',
    register: 'Registro',
    logout: 'Cerrar Sesión',
    fillForm: 'Por favor complete el formulario a continuación',
    fullName: 'Su Nombre Completo',
    fullNamePlaceholder: 'Ingrese su nombre completo',
    phone: 'Su Teléfono',
    phonePlaceholder: '06 XX XX XX XX',
    city: 'Ciudad',
    selectCity: 'Elija su ciudad',
    businessType: 'Su Tipo de Actividad',
    selectBusinessType: 'Seleccione su tipo de actividad'
  },
  cities: {
    casablanca: 'Casablanca',
    rabat: 'Rabat',
    marrakech: 'Marrakech',
    fes: 'Fez',
    tanger: 'Tánger',
    agadir: 'Agadir',
    meknes: 'Mequinez',
    oujda: 'Uchda',
    kenitra: 'Kenitra',
    tetouan: 'Tetúan',
    sale: 'Salé',
    nador: 'Nador',
    mohammedia: 'Mohammedia',
    eljadida: 'El Jadida',
    benimellal: 'Beni Mellal',
    other: 'Otro'
  },
  businessTypes: {
    epicerie: 'Tienda de Comestibles',
    parapharmacie: 'Parafarmacia',
    cafe_restaurant: 'Café Restaurante',
    boulangerie_patisserie: 'Panadería Pastelería',
    meule: 'Molino',
    vetement: 'Ropa',
    atelier: 'Taller',
    service_maintenance: 'Servicio de Mantenimiento'
  },
  common: {
    cancel: 'Cancelar',
    send: 'Enviar',
    sending: 'Enviando...'
  },
  mobile: {
    menu: 'Abrir menú'
  }
}; 